import { AddEquation, AdditiveBlending, DstColorFactor, Mesh, MultiplyBlending, Object3D, PlaneBufferGeometry, RawShaderMaterial, SrcColorFactor } from "three";

export default class Vignette extends Object3D {
  constructor(){
    super()
    const geo = new PlaneBufferGeometry(2, 2, 1, 1)
    const mat = new RawShaderMaterial({
      vertexShader: /* glsl */`#version 300 es
      in vec3 position;
      in vec2 uv;

      out vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = vec4(position, 1.0);
      }
      `,
      fragmentShader: /* glsl */`#version 300 es
      precision highp float;
      in vec2 vUv;
      uniform vec2 resolution;
      out vec4 outColor;

      highp float basicDithering (in highp vec2 st, highp float intensity) {
        return mix(
            -intensity/ 255.,
            intensity/255.,
            fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123)
        );
      }


      void main() {
        float dither = basicDithering(gl_FragCoord.xy, 6.0);
        float aspect = resolution.x / resolution.y;
        vec2 q = vec2(vUv - 0.5);
        q.y /= aspect;
        float dst = length(q);
        dst = smoothstep(0.0, 0.8, dst);
        vec4 color1 = vec4(0.0);
        vec4 color2 = vec4(0.0, 0.0, 0.0, 1.0);
        vec4 color = mix(color1, color2, dst);
        color.rgb += dither;
        outColor = color;
      }
      `,
      uniforms: {
        resolution: { value: [window.innerWidth, window.innerHeight] },
      },
      transparent: true,
      depthTest: false,
      depthWrite: false,
    })

    const mesh = new Mesh(geo, mat)
    mesh.frustumCulled = false
    this.add(mesh)
  }
}